import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Radio, FormControlLabel, DialogActions, Dialog, DialogTitle, DialogContent, DialogContentText } from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import {
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "./FuiStyles";
import { quickConfiguration, fullConfiguration } from "./Constants/LongText";
import * as fuiRedux from "../../redux/fui/index";
import {
  ATRFormModel,
  EventOpsFormModel,
  DOAFormModel,
  TAFormModel,
  DPFormModel,
  GWLFormModel,
  ADFormModel,
  WPFormModel,
  MPFormModel,
  PIFormModel,
  SPFormModel,
  REFormModel,
  PAMFormModel,
  UTKMFormModel,
  SplunkClusterFormModel,
  Stack360FormModel,
  StormWatchFormModel,
  StormSeerFormModel,
  OPSFormModel,
  TuringFormModel,
  GAFormModel,
  // CPFormModel,
  // BRFormModel,
  ECCFormModel,
  AALFormModel,
  // KQFormModel,
  SIFormModel,
} from "../../constants/formModels";
import PropTypes from "prop-types";
import { CommonDialogV2 } from "../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../common/CommonComponents/Buttons";
import { clearAllValidationHooks } from "./forms/useFormValidationWithBorders";
/**
 * Handles the configuration type of a form
 * @author Xiao Luo
 * @version 1.0
 * @see Used in component: AppStepper and all forms.
 */
const ConfigurationType = ({
  setConfigurationType,
  configurationType,
  clearDPForm,
  clearGWLForm,
  clearADForm,
  clearWPForm,
  clearMPForm,
  clearPIForm,
  clearTAForm,
  clearDOAForm,
  clearATRForm,
  clearEOForm,
  clearOPSForm,
  clearSPForm,
  clearREForm,
  clearPAMForm,
  clearUTKMForm,
  clearSPLUCLUForm,
  clearStack360Form,
  clearStormWatchForm,
  clearStormSeerForm,
  clearLocalComponentData,
  clearIsRootExisted,
  clearExternalClientData,
  clearTuringForm,
  clearGAForm,
  // clearCPForm,
  // clearBRForm,
  clearECCForm,
  clearAALForm,
  // clearKQForm,
  clearSIForm,
  clearIsWBSEValid,
  productname
}) => {
  const [isQuickConfiguration, setIsQuickConfiguration] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingConfigType, setPendingConfigType] = useState(null);

  useEffect(() => {
    if (configurationType.length > 0) {
      let configurationTypeValue = configurationType === "quick" ? true : false;
      setIsQuickConfiguration(configurationTypeValue);
    }
  }, [configurationType]);

  // Handle configuration type change with confirmation
  const handleConfigurationChange = (e) => {
    const newConfigType = e.target.value;

    // If this is the initial load or same value, no confirmation needed
    if (!configurationType || configurationType === newConfigType) {
      clearForm(e, "configurationType");
      return;
    }

    // Show confirmation dialog for actual changes
    setPendingConfigType(newConfigType);
    setShowConfirmDialog(true);
  };

  // Confirm configuration change and clear form
  const confirmConfigurationChange = () => {
    const mockEvent = { target: { value: pendingConfigType } };
    clearForm(mockEvent, "configurationType");
    setShowConfirmDialog(false);
    setPendingConfigType(null);

    // Clear any validation states and red borders
    clearValidationStates();
  };

  // Cancel configuration change
  const cancelConfigurationChange = () => {
    setShowConfirmDialog(false);
    setPendingConfigType(null);
  };

  // Clear all validation states and visual indicators
  const clearValidationStates = () => {
    // Clear red borders - target fieldset elements specifically
    const fieldsets = document.querySelectorAll('fieldset');
    fieldsets.forEach(fieldset => {
      fieldset.style.border = '';
    });

    // Clear red borders from any element with red border styling
    const elementsWithRedBorders = document.querySelectorAll('[style*="#E20000"], [style*="rgb(226, 0, 0)"]');
    elementsWithRedBorders.forEach(element => {
      element.style.border = '';
      element.style.outline = '';
    });

    // Clear red outlines from wrapper elements
    const wrapperElements = document.querySelectorAll('#Genwizard_Core_wrapper, #Genwizard_agent_wrapper');
    wrapperElements.forEach(wrapper => {
      wrapper.style.outline = '';
    });

    // Clear any input fields with red borders
    const inputs = document.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      if (input.style.border && input.style.border.includes('#E20000')) {
        input.style.border = '';
      }
      // Also clear parent fieldset if it has red border
      const parentFieldset = input.closest('fieldset');
      if (parentFieldset && parentFieldset.style.border && parentFieldset.style.border.includes('#E20000')) {
        parentFieldset.style.border = '';
      }
    });
  };

  const clearForm = (e, configurationType) => {
    setConfigurationType(e, configurationType);
    clearDPForm(DPFormModel);
    clearGWLForm(GWLFormModel);
    clearADForm(ADFormModel);
    clearWPForm(WPFormModel);
    clearMPForm(MPFormModel);
    clearPIForm(PIFormModel);
    clearTAForm(TAFormModel);
    clearDOAForm(DOAFormModel);
    clearATRForm(ATRFormModel);
    clearEOForm(EventOpsFormModel);
    clearTuringForm(TuringFormModel);
    clearGAForm(GAFormModel);
    clearOPSForm(OPSFormModel);
    clearSPForm(SPFormModel);
    clearREForm(REFormModel);
    clearPAMForm(PAMFormModel);
    clearUTKMForm(UTKMFormModel);
    clearSPLUCLUForm(SplunkClusterFormModel);
    clearStack360Form(Stack360FormModel);
    clearStormWatchForm(StormWatchFormModel);
    clearStormSeerForm(StormSeerFormModel);
    // clearCPForm(CPFormModel);
    // clearBRForm(BRFormModel);
    clearECCForm(ECCFormModel);
    clearAALForm(AALFormModel);
    // clearKQForm(KQFormModel);
    clearSIForm(SIFormModel);
    clearLocalComponentData();
    clearIsRootExisted();
    clearExternalClientData();
    // Clear WBSE validation state (removes green check icons and validation status)
    clearIsWBSEValid();

    // Clear all validation states and red borders (with delay to ensure DOM updates)
    setTimeout(() => {
      // Clear all validation hook states first
      clearAllValidationHooks();
      // Then clear any remaining visual indicators
      clearValidationStates();
    }, 300);
  };

  return (
    <div>
      {(productname !== 'AgentMesh' && productname !== 'CIA') &&
        <>
          <TopRadioWrapper>
            <ConfigurationFormLabel component="legend">
              ORDER TYPE
            </ConfigurationFormLabel>

            <StyledRadioGroup
              aria-label="configurationType"
              name="configurationType"
              value={configurationType}
              onChange={handleConfigurationChange}
              row
            >
              <FormControlLabel
                checked={isQuickConfiguration === false}
                value="full"
                control={<Radio color="primary" />}
                // label={`CLIENT (${fullConfiguration})`}
                label={`CLIENT`}
              />
              <div>
                <FormControlLabel
                  checked={isQuickConfiguration}
                  value="quick"
                  control={<Radio color="primary" />}
                  // label={`INTERNAL (${quickConfiguration})`}
                  label={`INTERNAL USER`}
                />

              </div>
            </StyledRadioGroup>
          </TopRadioWrapper>
          {configurationType == "quick" ?
            <div>
              <em style={{ fontSize: "small", color: " #0041F0" }}>
                “I acknowledge that my cost owner is accountable for the cost of this internal/testing instance and will be subject to regular auditing. I also confirm that no client-related data will be entered or used in this instance."</em>
            </div> :
            <div>
              <em style={{ fontSize: "small", color: " #0041F0" }}>“Please keep valid/active SAP Contract ID and End-to-End UID respective to the client you select"</em>
            </div>
          }
        </>
      }

      {/* Configuration Change Confirmation Dialog */}
      <Dialog open={showConfirmDialog} onClose={cancelConfigurationChange} fullWidth={false}>
        <DialogTitle
          style={{
            backgroundColor: "#7500C0",
            color: '#FFFFFF',
            height: '50px',
            padding: '5px 20px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          Confirm Configuration Change
        </DialogTitle>
        <DialogContent style={{ overflowY: "unset", width: '450px' }}>
          <DialogContentText style={{ fontSize: '.9em', color: "#666666", fontWeight: "400" }}>
            <div style={{ fontFamily: 'Graphik, sans-serif', padding: '20px 0' }}>
              <div style={{
                marginBottom: '20px',
                padding: '16px 20px',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                color: '#856404',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <WarningIcon style={{ marginRight: '8px', fontSize: '18px', color: '#f79738' }} />
                Switching order type will reset the form.
              </div>

              <div style={{ fontSize: '.9rem', lineHeight: '1.5', color: '#333', padding: '0 4px' }}>
                You are switching from <strong>{configurationType === 'quick' ? 'INTERNAL USER' : 'CLIENT'}</strong> to <strong>{pendingConfigType === 'quick' ? 'INTERNAL USER' : 'CLIENT'}</strong> configuration.
                <br /><br />
                {(productname === 'GenwizardAgent' && configurationType !== 'quick') &&
                  <>
                    <span style={{ color: '#5d00a3' }}>
                      <strong>Note: </strong>Agent Manager required a valid Contract ID and RITM
                    </span><br />
                  </>
                }
                <br />
                Do you want to continue?
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px 20px 24px' }}>
          <AcceptButton2
            onClick={cancelConfigurationChange}
            label="No"
            style={{
              marginRight: '8px',
              backgroundColor: '#EBEBEB',
              color: '#333',
              width: '100px',
              fontWeight: '500'
            }}
          />
          <AcceptButton2
            onClick={confirmConfigurationChange}
            label="Yes"
            style={{
              backgroundColor: '#7500C0',
              color: 'white',
              width: '100px',
              fontWeight: '500'
            }}
          />
        </DialogActions>
      </Dialog>

    </div>
  );
};

const MSTP = (state, ownProps) => ({
  configurationType: state.fui.configurationType,
});

ConfigurationType.propTypes = {
  /**
   * Redux function to set the configuration type of a form
   */
  setConfigurationType: PropTypes.func,
  /**
   * Allows you to clear the dedicated platform redux state
   */
  clearDPForm: PropTypes.func,
  /**
   * Allows you to clear the windows provisioning platform redux state
   */
  clearWPForm: PropTypes.func,
  /**
   *
   */
  clearLocalComponentData: PropTypes.func,
  /**
   *
   */
  clearIsRootExisted: PropTypes.func,
};

export default connect(MSTP, {
  setConfigurationType: fuiRedux.setConfigurationType,
  clearDPForm: fuiRedux.clearDPForm,
  clearGWLForm: fuiRedux.clearGWLForm,
  clearADForm: fuiRedux.clearADForm,
  clearWPForm: fuiRedux.clearWPForm,
  clearMPForm: fuiRedux.clearMPForm,
  clearPIForm: fuiRedux.clearPIForm,
  clearTAForm: fuiRedux.clearTAForm,
  clearDOAForm: fuiRedux.clearDOAForm,
  clearATRForm: fuiRedux.clearATRForm,
  clearEOForm: fuiRedux.clearEOForm,
  clearTuringForm: fuiRedux.clearTuringForm,
  clearGAForm: fuiRedux.clearGAForm,
  clearOPSForm: fuiRedux.clearOPSForm,
  clearSPForm: fuiRedux.clearSPForm,
  clearREForm: fuiRedux.clearREForm,
  clearPAMForm: fuiRedux.clearPAMForm,
  clearUTKMForm: fuiRedux.clearUTKMForm,
  clearSPLUCLUForm: fuiRedux.clearSPLUCLUForm,
  clearStack360Form: fuiRedux.clearStack360Form,
  clearStormWatchForm: fuiRedux.clearStormWatchForm,
  clearStormSeerForm: fuiRedux.clearStormSeerForm,
  clearLocalComponentData: fuiRedux.clearLocalComponentData,
  clearIsRootExisted: fuiRedux.clearIsRootExisted,
  clearExternalClientData: fuiRedux.clearExternalClientData,
  // clearCPForm: fuiRedux.clearCPForm,
  // clearBRForm: fuiRedux.clearBRForm,
  clearECCForm: fuiRedux.clearECCForm,
  clearAALForm: fuiRedux.clearAALForm,
  // clearKQForm: fuiRedux.clearKQForm,
  clearSIForm: fuiRedux.clearSIForm,
  clearIsWBSEValid: fuiRedux.clearIsWBSEValid,
})(ConfigurationType);
